export default __webpack_public_path__ + "static/media/404.fb6f358a.png";